import React, { useEffect } from 'react';
import './home.css'; 
import HomePage from '../HomePage/HomePage';
import BrandStrip from '../BrandStrip/BrandStrip';

import TeamSection from '../TeamMembers/TeamMembers';
import GetInTouchSection from '../GetInTouch/GetInTouch';
import HeroTrust from '../HeroTrust/HeroTrust';

import Partners from '../Partners/Partners';

const Home: React.FC = () => {
    useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove if you want instant
    });
  }, []);
  return (
    <>
   <HomePage/>
   {/* <AboutSection/> */}
   <HeroTrust/>
   <Partners/>
   <BrandStrip/>
   <GetInTouchSection/>
   <TeamSection/>
   {/* <BlogsAndInsights/> */}
   </>
  );
};

export default Home;
